module dg.objects {

    class nyaSelectController {

        public value: dg.domain.model.DomainModelRefInfo | dg.domain.model.DomainModelRefInfo[];
        private propMeta: dg.restfulApi.DomainObjectPropertyMetadata;

        public ngModel: ng.INgModelController;
        public domainObjectCtrl: ObjectEditorController;

        private dgQueryItems: string;
        private multiple: string;
        public dataLoaded: boolean;
        public searchValue: string;
        public isDropdownExpanded: boolean = true;

        private form: any;
        private propLookupData: dg.domain.model.DomainModelRefInfo[];
        private formEditor: FormEditorController;
        public shouldSelectItem: boolean = false;

        public constructor(
            private $element: ng.IAugmentedJQuery,
            private $scope: ng.IScope,
            private actionService: dg.actions.ActionService,
            private commandExecutedChannelService: dg.actions.CommandExecutedChannelService,
            private dgGuid: dgUtils.DgGuid
        ) { }

        $onInit() {
            // this.compile(this.$element);
            if (!this.value) {
                this.propLookupData = [];
            } else {
                if (this.value instanceof Array) {
                    this.propLookupData = this.value;
                } else {
                    this.propLookupData = [this.value];
                }
            }

            this.commandExecutedChannelService.onCommandExecuted(this.$scope, c => {
                let invokeLink = c.dgMeta.links[c.dgMeta.id + '_invoke'];
                if (this.propMeta.links.add && invokeLink.urnTemplate == this.propMeta.links.add.urnTemplate) {
                    let newItemId = this.shouldSelectItem ? (c as dg.domain.commands.AggregateCommandBase).aggregateId : null;
                    this.refreshData(newItemId);
                }
            });
        }
        public triggerAddItem(item) {
            this.shouldSelectItem = true;
        }

        public linkClick() {
            if (!this.dataLoaded) {
                this.refreshData(null);
            }
        }

        public onSelected() {
            this.isDropdownExpanded = false;
        }

        public clear = () =>{
            this.value = null;
        }

        public refreshData(addedItemId) {

            if (this.propMeta.links.lookupResult && !this.propMeta.readOnly) {
                this.actionService.getQueryResult(this.propMeta.links.lookupResult.href).then((lookupData: any) => {
                    this.propLookupData = <domain.model.DomainModelRefInfo[]>lookupData.items;
                    this.fixLookupDataObjectByModel(this.propLookupData);

                    if (addedItemId) {
                        let item = this.propLookupData.filter(i => i.id == addedItemId)[0];
                        if (this.value instanceof Array) {
                            this.value.push(item);
                        } else {
                            this.value = item;
                        }
                    }
                    this.dataLoaded = true;

                }, angular.noop);
            }
        };


        //fix ngModel object equality on load
        fixLookupDataObjectByModel(propLookupDataArray: dg.domain.model.DomainModelRefInfo[]) {

            if (this.value instanceof Array) {
                if (this.value.length > 0) {
                    for (var index = 0; index < propLookupDataArray.length; ++index) {
                        let object = propLookupDataArray[index];

                        for (var modelIndex = 0; modelIndex < this.value.length; ++modelIndex) {
                            let modelObj = this.value[modelIndex];
                            if (object.id == modelObj.id) {
                                propLookupDataArray[index] = modelObj;
                                break;
                            }
                        }
                    }
                }
            }
            else {
                if (this.value) {
                    var found = false;
                    for (var index = 0; index < propLookupDataArray.length; ++index) {
                        let object = propLookupDataArray[index];
                        if (object.id == this.value.id) {
                            //propLookupDataArray[index] = this.value;
                            this.value = propLookupDataArray[index];
                            found = true;
                            break;
                        }
                    }
                    // Add the currently selected item to the list, because it might not be there.
                    // For example, when changing the matched performed leg, the current one is not in the list
                    // because its FlightLegId is already filled.
                    if (!found) {
                        propLookupDataArray.push(this.value);
                    }
                }
            }
        }
    }

    angular.module('dg.objects').component('nyaSelect', {
        bindings: {
            value: '=ngModel', //TODO: '<'
            propMeta: '<'
        },
        require: {
            formEditor: '?^formEditor',
            ngModel: 'ngModel',
            domainObjectCtrl: '^objectEditor'
        },
        controller: nyaSelectController,
        templateUrl: ($element, $attrs: any) => {
            return '/digmo/src/objects/properties/lookup/nya-select.html'
        }
    });
}